// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root"};